import { Injectable } from "@angular/core";
import { CanActivate, Router } from "@angular/router";
import { appConfig } from "../../insaweb.config";

@Injectable()
export class ForgotPasswordGuard implements CanActivate {
	constructor(private _router: Router) {}

	canActivate(): boolean {
		const visible =
			(appConfig as any).showForgotPasswordButtonOnLogin === undefined
				? false
				: (appConfig as any).showForgotPasswordButtonOnLogin;
		if (!visible) {
			this._router.navigate(["/login"]);
			return false;
		}
		return true;
	}
}



// WEBPACK FOOTER //
// ./app/insa-services/forgot-password.guard.ts